import { render, staticRenderFns } from "./physicianDetail.vue?vue&type=template&id=6cec7686&scoped=true&"
import script from "./physicianDetail.vue?vue&type=script&lang=js&"
export * from "./physicianDetail.vue?vue&type=script&lang=js&"
import style0 from "./physicianDetail.vue?vue&type=style&index=0&id=6cec7686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec7686",
  null
  
)

export default component.exports